import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../utils/api';
import ViewForm from '../../../component/reusable/ViewForm';

const ViewSubCategories = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const { id } = useParams()

  const fetchsubcategoryDetails = async () => {
      setLoading(true)
      try {
          const { data, status } = await api.viewsubCategory(id)
          console.log(data?.data);

          if (status == 200) {
              setData(data?.data);
          }
      } catch (err) {
          console.log(err);
      } finally {
          setLoading(false)
      }
  }


  useEffect(() => {
      if (id) {
          fetchsubcategoryDetails()
      }
  }, [id])

  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Categories"  pagename="View SubCategory"/>
      {loading ? <div>Please wait...</div>
        :
        <ViewForm data={data} from={'Subcategory Name*'}/>
      }
    </div>
  );
};

export default ViewSubCategories;
